// extracted by mini-css-extract-plugin
export default {"confirmationMessage":"tell-us-why-modal__confirmationMessage__GMXva","errorMessage":"tell-us-why-modal__errorMessage__yfmCs"};